import localhost, { downloadFileFromResponse } from "apis/localhost";
import { modalTypes } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import { hideModal, showModal } from "slices/app/actions/modals";
import {
  addToJobQueue,
  clearJobQueue,
  showGlobalAlert,
} from "slices/app/appSlice";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import { systemAdminImportUsersFromCsvConfirmationModal } from "components/Modal/confModalTypes";
import { setUsersInfo } from "slices/systemAdmin/systemAdminSlice";

export const fetchUsers = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));
  await localhost
    .get("/docs/systemAdmin/users")
    .then(async (response) => {
      const { data } = response;
      dispatch(setUsersInfo(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const createUser =
  (userName, firstName, lastName, password, systemAdmin) =>
  async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));
    await localhost
      .post("/docs/systemAdmin/user", {
        userName,
        firstName,
        lastName,
        password,
        systemAdmin,
      })
      .then(async (response) => {
        const { data } = response;
        dispatch(setUsersInfo(data));
        dispatch(hideModal(modalTypes.NEW_USER));
        dispatch(
          showGlobalAlert({
            variant: alertVariants.success,
            text: "User Created Successfully",
          })
        );
      })
      .catch((error) => {
        dispatch(hideModal(modalTypes.NEW_USER));
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const editUser =
  (userName, firstName, lastName, password, systemAdmin) =>
  async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));
    await localhost
      .patch("/docs/systemAdmin/user", {
        userName,
        firstName,
        lastName,
        password,
        systemAdmin,
      })
      .then(async (response) => {
        const { data } = response;
        dispatch(setUsersInfo(data));
        dispatch(hideModal(modalTypes.EDIT_USER));
        dispatch(
          showGlobalAlert({
            variant: alertVariants.success,
            text: "User Successfully Updated",
          })
        );
      })
      .catch((error) => {
        dispatch(hideModal(modalTypes.EDIT_USER));
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const deleteUser = (username) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));
  await localhost
    .delete(`/docs/systemAdmin/user`, {
      params: { username },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setUsersInfo(data));
      dispatch(hideModal(modalTypes.CONFIRMATION));
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: `User ${username} successfully deleted from the system`,
        })
      );
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.EDIT_USER));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const exportActivityReport = (filter) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/systemAdmin/activity", {
      responseType: "blob",
      params: { filter },
    })
    .then(async (response) => {
      const { data } = response;

      downloadFileFromResponse(data, "ActivityReport.csv");

      dispatch(hideModal(modalTypes.EXPORT_REPORT));
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.EXPORT_REPORT));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const importUsersFromCsv = (formData) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/systemAdmin/importUsers", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async (response) => {
      const { data } = response;
      if (response.status === 200) {
        dispatch(setUsersInfo(data.usersResponse));
      }
      dispatch(hideModal(modalTypes.IMPORT_USERS));
      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          systemAdminImportUsersFromCsvConfirmationModal(
            data.usersResultString,
            data.message,
            dispatch
          )
        )
      );
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.IMPORT_USERS));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const exportResultsImportUsersFromCsv =
  (results) => async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));

    await localhost
      .get("/docs/systemAdmin/exportUsersResult", {
        responseType: "blob",
        params: { usersString: results },
      })
      .then(async (response) => {
        const { data } = response;

        downloadFileFromResponse(data, "BulkUserResults.csv");

        dispatch(hideModal(modalTypes.CONFIRMATION));
      })
      .catch((error) => {
        dispatch(hideModal(modalTypes.CONFIRMATION));
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const exportUserList = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/systemAdmin/exportUserList", {
      responseType: "blob",
      params: {},
    })
    .then(async (response) => {
      const { data } = response;

      downloadFileFromResponse(data, "UserList.csv");

      dispatch(hideModal(modalTypes.CONFIRMATION));
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.CONFIRMATION));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};
export const userLogOut = (username) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/systemAdmin/logout", null, {
      params: { username },
    })
    .then(async () => {
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: "User logged out successfully",
        })
      );
      dispatch(fetchUsers());
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};
